import { LAB_ORDER_STATUS, LAB_ORDER_STATUS_CONFIG } from "../constants";

// Backend submission statuses (LaboratoryOrderSubmissionStatus).
const SUBMISSION_STATUS = {
  pending: "PENDING",
  accepted: "ACCEPTED",
  rejectedSystem: "REJECTED_SYSTEM",
  rejectedWorklist: "REJECTED_WORKLIST",
};

// A lab order carries two independent facts:
//   downloaded       — the GP completed the order in Healthlink's Integrated
//                      Browser and Healthlink handed us the finished document
//   submissionStatus — what the hospital laboratory answered (ORL_O22)
// The laboratory's answer always wins: it is the clinically meaningful one, and
// an answer can only exist for an order that was actually placed.
// An unrecognised status resolves to "submitted" — never invent a rejection and
// never claim an acceptance we were not told about.
export const deriveLabOrderStatus = ({ downloaded, submissionStatus } = {}) => {
  if (submissionStatus === SUBMISSION_STATUS.accepted) {
    return LAB_ORDER_STATUS.accepted;
  }

  if (submissionStatus === SUBMISSION_STATUS.rejectedSystem) {
    return LAB_ORDER_STATUS.rejected;
  }

  if (submissionStatus === SUBMISSION_STATUS.rejectedWorklist) {
    return LAB_ORDER_STATUS.removedFromWorklist;
  }

  if (submissionStatus === SUBMISSION_STATUS.pending || !submissionStatus) {
    return downloaded
      ? LAB_ORDER_STATUS.submitted
      : LAB_ORDER_STATUS.awaitingCompletion;
  }

  return LAB_ORDER_STATUS.submitted;
};

export const getLabOrderStatusConfig = (order) =>
  LAB_ORDER_STATUS_CONFIG[deriveLabOrderStatus(order)];

// True while the GP still has to finish the order in Healthlink.
export const isAwaitingCompletion = (order) =>
  deriveLabOrderStatus(order) === LAB_ORDER_STATUS.awaitingCompletion;

// True while no laboratory answer has arrived — the order is placed but not yet
// acknowledged, which is what the "waiting for the laboratory" notice reflects.
export const isAwaitingLaboratoryResponse = (order) =>
  deriveLabOrderStatus(order) === LAB_ORDER_STATUS.submitted;

// The laboratory removed the order from its work list — the reason it gave must
// reach the GP (National GP Laboratory Ordering Specification, ORL_O22).
export const requiresGpVisibleReason = (order) =>
  deriveLabOrderStatus(order) === LAB_ORDER_STATUS.removedFromWorklist;

export { SUBMISSION_STATUS };
